//分类接口

import request from '../request';


//(条件)分页查询
export const reqGetPageData = (data) => request({ url:'/admin/category/page', method:'get', params:data });

//新增
export const reqAddData = (data) => request({ url:'/admin/category/save', method:'post', data });

//删除
export const reqDeleteData = (id) => request({ url:`/admin/category/delete/${id}`, method:'delete'});

//修改
export const reqUpdateData = (data) => request({ url:'/admin/category/update', method:'put', data });

//调整状态
export const reqUpdateStatus = (status, id) => request({ url:`/admin/category/status/${status}/${id}`, method:'post' });
